import type { FormEvent } from 'react';
import { NAME_MAX_LENGTH } from '@arena/shared';
import { useSettingsStore } from '../../store/settingsStore';

/** The name counter appears once the name gets close to the limit. */
export const NAME_COUNTER_FROM = 12;

/** Home → your name, saved as you type. Enter submits (opens Play). */
export function NameField({ onSubmit }: { onSubmit: () => void }) {
  const name = useSettingsStore((s) => s.name);
  const setName = useSettingsStore((s) => s.setName);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };
  return (
    <form className="name-field" onSubmit={submit}>
      <label className="field">
        <span className="field-label">
          Name
          {name.length >= NAME_COUNTER_FROM && (
            <span className="muted name-counter">
              {name.length}/{NAME_MAX_LENGTH}
            </span>
          )}
        </span>
        <input
          value={name}
          maxLength={NAME_MAX_LENGTH}
          placeholder="Your name"
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
      </label>
    </form>
  );
}
